export const MIN_COORDINATE_DIGITS = 3

export function formatCoordinatePart(value: number): string {
  const coordinate = Math.round(value)
  const digits = String(Math.abs(coordinate)).padStart(
    MIN_COORDINATE_DIGITS,
    '0',
  )
  return coordinate < 0 ? `-${digits}` : digits
}

export function formatCoordinate(x: number, y: number): string {
  return `${formatCoordinatePart(x)}|${formatCoordinatePart(y)}`
}
